// apps/web/src/features/dashai/lib/learningExtractorClient.ts
//
// Client helper for the dashaiLearningExtractor Firebase function.
// Mirrors forge-explorer / win-back wrappers.

export { postWithAuthRetry } from './onePSfaClient';

/** dashaiLearningExtractor URL: explicit override → derived from the
 * standard Firebase Functions base → undefined. */
export function getLearningExtractorUrl(): string | undefined {
  const explicit = import.meta.env.VITE_LEARNING_EXTRACTOR_URL as string | undefined;
  if (explicit) return explicit;
  const base = import.meta.env.VITE_FIREBASE_FUNCTIONS_URL as string | undefined;
  if (base) return `${base.replace(/\/+$/, '')}/dashaiLearningExtractor`;
  return undefined;
}
